export default (str, separator = "-") => (str || "").toLowerCase().replace(/ /g, separator);
